<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
  <div class="user team-hub">
    <div class="vtm-page-head">
      <div>
        <h1 class="vtm-page-head__title">{{ $t("teamHub.title") }}</h1>
        <div class="vtm-page-head__sub">{{ $t("teamHub.subtitle") }}</div>
      </div>
    </div>
    <div class="team-hub__seg">
      <el-radio-group v-model="hubView" size="small">
        <el-radio-button label="users">{{ $t("teamHub.tabUsers") }}</el-radio-button>
        <el-radio-button v-if="hubGrants.roles" label="roles">{{ $t("teamHub.tabRoles") }}</el-radio-button>
        <el-radio-button v-if="hubGrants.authorization" label="permissions">{{ $t("teamHub.tabPermissions") }}</el-radio-button>
      </el-radio-group>
    </div>
    <div v-show="hubView === 'users'">
    <search-user
      v-on:onSubmit="onSubmit"
      v-on:resetSearch="resetSearch"
      v-on:addUser="addUser"
      v-on:configPaypal="configPaypal"
      v-on:configCashu="configCashu"
      :search="search"
      :uid="uid"
    >
    </search-user>
    <add-user
      :userTypeList="userTypeList"
      :timeZoneList="timeZoneList"
      :countryList="countryList"
      v-on:cancel="cancel"
      :dialogAddUser="dialogAddUser"
      :userForm="userForm"
    >
    </add-user>
    <div class="vue-padding radius">
      <el-table
        v-loading="loading"
        :empty-text="$t('common.noData')"
        :element-loading-text="$t('common.loading')"
        :data="userList"
        style="width: 100%"
        max-height="638"
        :border="true"
        @sort-change="sortChange"
      >
        <el-table-column
          prop="createName"
          :label="$t('user.createName')"
          width="150"
          :align="'center'"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="userName"
          :label="$t('user.userName')"
          width="150"
          :align="'center'"
          :show-overflow-tooltip="true"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="domainName"
          :label="$t('user.domainName')"
          width="150"
          :align="'center'"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-button
              :id="'fz' + scope.$index"
              size="mini"
              type="primary"
              :data-clipboard-text="scope.row.domainName"
              @click="handleCopy(scope.row.loginLocale)"
              >{{ $t("userMachineLineProduct.copy") }}</el-button
            >
            <el-button size="mini" @click="handleEditDomain(scope.row)">{{ $t("user.edit") }}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="roleListLabel"
          :label="$t('user.userType')"
          width="200"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="nickName"
          :label="$t('user.nickName')"
          width="200"
          :align="'center'"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="phone"
          :label="$t('user.phone')"
          width="150"
          :align="'center'"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="timeZone"
          :label="$t('user.timeZone')"
          width="150"
          :align="'center'"
          :formatter="timeZone"
        ></el-table-column>
        <el-table-column
          prop="email"
          :label="$t('user.email')"
          :show-overflow-tooltip="true"
          width="250"
          :align="'center'"
        ></el-table-column>
        <el-table-column prop="insertType" :label="$t('user.regesitMethod')" width="200" :align="'center'">
          <template #default="scope">
            {{ scope.row.insertType == 0 ? $t("user.adminReg") : $t("user.userReg") }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
					:formatter="(row) => $formatDate(row.createTime)"
          :label="$t('user.createTime')"
          width="180"
          :align="'center'"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          fixed="right"
          :label="$t('common.operate')"
          :width="$i18n.locale == 'zh_CN' ? 460 : 540"
        >
          <template slot-scope="scope">
            <el-button size="mini" type="text" v-hasPerm="['sys:user:update']" @click="editUser(scope.row)">{{
              $t("common.edit")
            }}</el-button>
            <el-button size="mini" type="text" v-hasPerm="['user:reset:password']" @click="reset(scope.row)">{{
              $t("user.reset")
            }}</el-button>
            <el-button
              size="mini"
              v-hasPerm="['sys:user:linkjump']"
              type="success"
              icon="el-icon-position"
              @click="handleJump(scope.row)"
              >{{ $t("machineUser.jump") }}</el-button
            >
            <el-button
              v-if="scope.row.stripeCus === ''"
              @click="handleCreateStripe(scope.row)"
              size="mini"
              v-hasPerm="['sys:user:stripes']"
              type="primary"
              icon="el-icon-plus"
              >{{ $t("user.User.467062-0") }}</el-button
            >
            <el-button
              v-if="scope.row.stripeCus !== '' && $cookies.get('userName') === 'ramya@vapetm.com'"
              @click="handleConsolidateUser(scope.row)"
              size="mini"
              type="warning"
              icon="el-icon-refresh"
              :loading="consolidatingUserId === scope.row.id"
              >Consolidate</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,sizes,prev, pager, next,jumper"
        :current-page="page.pageIndex"
        :total="page.totalSize"
        :page-size="page.pageSize"
        @current-change="currentChange"
      ></el-pagination>
    </div>
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('user.xgqzyuming')"
      :visible.sync="dialogLogin"
      width="400px"
      :before-close="handleClose"
      custom-class="domains"
    >
      <div>{{ $t("user.dqyuming") }}{{ localDomain }}</div>
      <div>
        <div style="margin: 10px 0 5px 0">
          {{ $t("user.qzyuming") }}
        </div>
        <el-input v-model="domain" :placeholder="$t('user.hqzyuming')"></el-input>
      </div>
      <span slot="footer" class="dialog-footer" style="padding-top: 0">
        <el-button @click="dialogLogin = false">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" @click="handleConfirm">{{ $t("common.definite") }}</el-button>
      </span>
    </el-dialog>
    <!-- 账号关联dialog -->
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="nowUserInfo.nickName + $t('machineUser.accountAssociation')"
      :visible.sync="dialogAssociation"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form :model="associationForm" class="demo-ruleForm">
        <el-form-item prop="ids">
          <template id="label"><span style="color: red">*</span> {{ $t("machineUser.accountChoose") }}</template>
          <Wselect
            style="width: 400px"
            :hasAll="false"
            :multiple="true"
            styleSize="medium"
            v-model="associationForm.relevanceUserIds"
            :options="associationList"
            :loading="loading"
            @visibleChange="visibleChange"
            @loadMore="loadMore"
            @remoteMethod="remoteMethod"
            @change="change"
          ></Wselect>
        </el-form-item>
      </el-form>
      <el-row style="margin: 60px 0 15px">
        <el-col :span="24">
          {{ $t("machineUser.accountAssociationed") }}
          <el-button style="margin-left: 10px" size="mini" type="danger" icon="el-icon-delete" @click="handlerPlDel">
            {{ $t("machineUser.pDel") }}
          </el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" class="tableC">
          <!-- 已关联账号 -->
          <el-table
            :data="associatedList"
            style="width: 100%"
            border
            @selection-change="handleSelectionChange"
            :header-cell-style="{
              padding: '0px',
              color: 'var(--vtm-ink-2)',
              'text-align': 'center',
              fontWeight: 'normal',
              backgroundColor: 'var(--vtm-surface) !important',
              'border-bottom': '1px solid var(--vtm-line) !important'
            }"
            :cell-style="{ 'text-align': 'center', padding: '0px' }"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="userName" :label="$t('userMachineAlarm.userName')"> </el-table-column>
            <el-table-column prop="nickName" :label="$t('user.nickName')"> </el-table-column>
            <el-table-column prop="roleName" :label="$t('user.userType')"> </el-table-column>
            <el-table-column label="操作" width="150">
              <template #default="scope">
                <el-button type="text" @click="handlerDelAssociated(scope.row)">{{ $t("common.delete") }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-pagination
            size="mini"
            background
            layout="prev, pager, next"
            :total="+associatedListPage.totalSize"
            :page-size="+associatedListPage.pageSize"
            @current-change="associationPageChange"
          >
          </el-pagination>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogAssociation = false">{{ $t("certificate.cancel") }}</el-button>
        <el-button size="small" type="primary" @click="handlerConfirm">{{ $t("certificate.continue") }}</el-button>
      </span>
    </el-dialog>
    <!-- 创建stripes -->
    <el-dialog
      :visible.sync="isShowCreateStripe"
      :title="$t('user.User.467062-2')"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="420px"
    >
      <div style="color: blue; text-align: center; font-size: 22px; margin-bottom: 10px">{{ userInfo.email }}</div>
      <div style="text-align: center">{{ $t("user.User.467062-3") }}</div>
      <div style="display: flex; justify-content: center; gap: 20px; margin-top: 20px">
        <el-button size="small" @click="isShowCreateStripe = false">{{ $t("user.User.467062-4") }}</el-button>
        <el-button size="small" type="primary" :loading="confirmLoading" @click="handleCreateStripeConfirm">{{
          $t("user.User.467062-5")
        }}</el-button>
      </div>
    </el-dialog>
    </div>
    <div v-if="hubView === 'roles'" class="sh-embed">
      <roles-panel v-if="rolesMounted" :can-authorization="hubGrants.authorization"></roles-panel>
    </div>
    <!-- 权限 = 线上的「功能权限」页（Functional authority）：真正生效的那一套 -->
    <div v-if="hubView === 'permissions'" class="sh-embed">
      <authorization-panel v-if="permissionsMounted"></authorization-panel>
    </div>
  </div>
</template>

<script>
  import searchUser from "_c/system/user/SearchUser";
  import addUser from "_c/system/user/AddUser";
  import Wselect from "_c/system/user/Wselect";
  import RolesPanel from "./components/RolesPanel.vue";
  import AuthorizationPanel from "@/views/authority/Authorization.vue";
  import { grantedLinks } from "@/utils/navSections";
  import { mapTimeZoneList } from "@/utils/timezoneLabels";
  export default {
    name: "User",
    components: {
      searchUser,
      addUser,
      Wselect,
      RolesPanel,
      AuthorizationPanel
    },
    computed: {
      // 分段各自对应一个旧页面的授权：子账号可能只被授予其中一部分
      hubGrants() {
        const g = grantedLinks(this.$store.state.menuList);
        return {
          roles: g.has("/authority/role"),
          authorization: g.has("/authority/authorization")
        };
      }
    },
    data() {
      return {
        hubView: "users",
        rolesMounted: false,
        permissionsMounted: false,
        search: {
          userName: "",
          nickName: "",
          phone: "",
          sort: "",
          order: ""
        },
        uid: this.$cookies.get("uid"),
        loading: false,
        page: {
          pageSize: 10,
          pageIndex: 1
        },
        userList: [],
        dialogAddUser: false,
        userTypeList: [],
        userForm: {
          id: "",
          userName: "",
          nickName: "",
          passWord: "",
          checkPassword: "",
          email: "",
          timeZone: "",
          phone: "",
          roleId: "",
          notes: "",
          locale: "",
          country: ""
        },
        timeZoneList: [],
        countryList: [],
        dialogLogin: false,
        domain: "",
        localDomain: "",
        localdomainid: "",
        localuserid: "",
        // 账号关联
        nowUserInfo: {},
        dialogAssociation: false,
        associationForm: {
          relevanceUserIds: []
        },
        associationList: [],
        associationPage: {
          pageIndex: 1,
          pageSize: 100
        },
        associationSelect: {
          userName: ""
        },
        multipleSelection: [],
        associatedListPage: {
          // 已关联分页
          pageIndex: 1,
          pageSize: 10,
          totalSize: 0
        },
        associatedList: [],
        // 权限
        isShowCreateStripe: false,
        userInfo: {},
        confirmLoading: false,
        consolidatingUserId: null
      };
    },
    mounted() {
      this.currentChange();
      this.listUserType();
      this.listTimeZone();
      this.listCountry();
    },
    watch: {
      // 首次切到某段才挂载对应页面，之后用 v-show/v-if 保留
      hubView(v) {
        if (v === "roles") {
          this.rolesMounted = true;
        } else if (v === "permissions") {
          this.permissionsMounted = true;
        }
      }
    },
    methods: {
      handleCreateStripeConfirm() {
        this.$confirm(this.$t("user.User.467062-6"), this.$t("user.User.467062-7"), {
          confirmButtonText: this.$t("user.User.467062-8"),
          cancelButtonText: this.$t("user.User.467062-4"),
          type: "warning"
        }).then(() => {
          this.confirmLoading = true;
          this.$api
            .request(this.$url.Stripe.add, this.$method.post, {
              user: this.userInfo,
              id: this.userInfo.id
            })
            .then(res => {
              if (res.code == 0) {
                this.$message.success(this.$t("user.User.467062-9"));
                this.isShowCreateStripe = false;
                this.currentChange();
              } else {
                this.$message.warning(res.msg);
              }
            })
            .catch(() => {
              this.$message.warning(this.$t("user.User.467062-10"));
            })
            .finally(() => {
              this.confirmLoading = false;
            });
        });
      },
      handleCreateStripe(row) {
        this.userInfo = row;
        this.isShowCreateStripe = true;
      },
      // sort
      sortChange(column) {
        if (column.order === "ascending") {
          this.search.order = "asc";
          this.search.sort = column.prop;
        } else if (column.order === "descending") {
          this.search.order = "desc";
          this.search.sort = column.prop;
        } else {
          delete this.search.sort;
          delete this.search.order;
        }
        this.page.pageIndex = 1;
        this.currentChange();
      },
      // 账号关联
      handlerAssociation(row) {
        // open
        this.nowUserInfo = row;
        console.log(this.nowUserInfo, "nowUserInfo");
        this.dialogAssociation = true;
        this.pageAllInit();
      },
      async pageAllInit() {
        // init
        this.associationForm.relevanceUserIds = [];
        this.associatedListPage.pageIndex = 1;
        this.associatedList = [];
        await this.getAssociatedList();
        await this.init();
      },
      associationPageChange(e) {
        console.log(e);
        this.associatedListPage.pageIndex = e;
        this.getAssociatedList();
      },
      getAssociatedList() {
        this.$api
          .request(this.$url.Association.associatedList, this.$method.get, {
            uId: localStorage.getItem("uId"),
            ...this.associatedListPage
          })
          .then(res => {
            console.log(res.data);
            if (res.code == 0) {
              this.associatedListPage.totalSize = res.data.total;
              this.associatedList = res.data.records;
            }
          });
      },
      handlerDelAssociated(row) {
        this.$confirm(this.$t("machineUser.confirmDelAssociation"), this.$t("certificate.tips"), {
          confirmButtonText: this.$t("certificate.continue"),
          cancelButtonText: this.$t("certificate.cancel"),
          type: "warning"
        }).then(() => {
          this.delAssociated([row.id]);
        });
      },
      handlerPlDel() {
        this.$confirm(this.$t("machineUser.confirmDelAssociation"), this.$t("certificate.tips"), {
          confirmButtonText: this.$t("certificate.continue"),
          cancelButtonText: this.$t("certificate.cancel"),
          type: "warning"
        }).then(() => {
          let arr = [];
          this.multipleSelection.forEach(item => {
            arr.push(item.id);
          });
          if (arr.length <= 0) {
            this.$message.warning(this.$t("user.User.467062-12"));
            return;
          }
          this.delAssociated(arr);
        });
      },
      delAssociated(ids) {
        this.$api
          .request(this.$url.Association.delAssociated, this.$method.delete, {
            uId: localStorage.getItem("uId"),
            ids
          })
          .then(res => {
            this.$message({
              message: res.msg,
              type: res.code == 0 ? "success" : "error"
            });
            if (res.code == 0) {
              this.getAssociatedList();
            }
          });
      },
      handlerConfirm() {
        // confirm
        console.log(this.associationForm);
        this.$api
          .request(this.$url.Association.association, this.$method.post, {
            uId: localStorage.getItem("uId"),
            ...this.associationForm
          })
          .then(res => {
            this.$message({
              message: res.msg,
              type: res.code == 0 ? "success" : "error"
            });
            if (res.code == 0) {
              this.dialogAssociation = false;
            }
          });
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      init: async function () {
        this.loading = true;
        // 获取选项数据，后端需支持 page  size  name搜索
        const res = await this.$api.request(this.$url.Association.userList, this.$method.get, {
          ...this.associationPage,
          ...this.associationSelect
        });
        this.associationList = res.data.records;
        this.loading = false;
      },
      change(value) {
        console.log(value);
      },
      visibleChange(state) {
        this.associationSelect.userName = "";
      },
      loadMore(page) {
        this.associationPage.pageIndex = page;
        this.init();
      },
      remoteMethod(query, page) {
        this.associationPage.pageIndex = page;
        this.associationSelect.userName = query;
        this.init();
      },
      //  编辑地址
      handleEditDomain(row) {
        this.localDomain = row.loginLocale;
        this.localdomainid = row.id;
        this.dialogLogin = true;
      },
      // 正则判断前置域名
      isAlphanumeric(input) {
        let letterNumberRegex = /^[0-9a-zA-Z]+$/;
        return letterNumberRegex.test(input);
      },
      handleConfirm() {
        let _self = this;
        if (!_self.domain) {
          _self.$notify({
            title: _self.$t("common.tip"),
            message: _self.$t("user.hqzyuming"),
            type: "warning"
          });
          return false;
        }
        if (!this.isAlphanumeric(_self.domain)) {
          _self.$notify({
            title: _self.$t("common.tip"),
            message: _self.$t("user.gsError"),
            type: "warning"
          });
          return false;
        }
        _self.dialogLogin = false;
        let djs = setTimeout(function () {
          clearTimeout(djs);
          _self
            .$confirm(_self.$t("user.qdwarning"), _self.$t("common.warning"), {
              confirmButtonText: _self.$t("common.definite"),
              cancelButtonText: _self.$t("common.cancel"),
              type: "warning"
            })
            .then(() => {
              _self.$api
                .request(_self.$url.User.domianmodify, _self.$method.put, {
                  id: _self.localdomainid,
                  loginLocale: _self.domain
                })
                .then(res => {
                  _self.domain = "";
                  if (res.code === 0) {
                    _self.currentChange(_self.page.pageIndex);
                  } else {
                    _self.$notify({
                      title: _self.$t("common.tip"),
                      message: res.msg,
                      type: "error"
                    });
                  }
                });
            })
            .catch(res => {
              console.log(res);
            });
        }, 400);
      },
      // 用户跳转
      handleJump(row) {
        let _self = this;
        this.$confirm(this.$t("machineUser.jumpConfig"), this.$t("common.warning"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        })
          .then(() => {
            this.$api
              .request(this.$url.User.loginJump, this.$method.get, {
                uId: row.id,
                lang: this.$i18n.locale
              })
              .then(res => {
                if (res.code === 0) {
                  console.log(res.data, 999);
                  if (res.data && res.data.menu.length > 0) {
                    let userInfo = res.data;
                    sessionStorage.setItem("localuserid", userInfo.uid);
                    localStorage.setItem("uId", userInfo.uid);
                    sessionStorage.setItem("parentId", userInfo.pid);
                    _self.$cookies.set("parentId", userInfo.pid);
                    _self.$store.dispatch("login", userInfo).then(() => {
                      _self.$store.state.nickName = userInfo.nickName;
                      _self.$store.dispatch("delAllViews");
                      _self.$router.push("/main");
                    });
                  } else if (res.data.menu.length <= 0) {
                    this.$message.warning(this.$t("api.noMenu"));
                  } else {
                    this.$message.warning(res.msg);
                  }
                } else {
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: res.msg,
                    type: "error"
                  });
                }
              });
          })
          .catch(res => {
            console.log(res);
          });
      },
      listUserType() {
        this.$api
          .request(this.$url.User.getByList, this.$method.get, { type: 1 })
          .then(res => {
            if (res.code == 0) {
              this.userTypeList = res.data;
            }
          })
          .catch(() => {
            this.loading = false;
          });
      },
      listTimeZone() {
        this.$api.dict("gp_time_zone").then(res => {
          if (res.code === 0) {
            // 转换为通俗时区名称（如 "Eastern Time (EST)"），提升可读性
            this.timeZoneList = mapTimeZoneList(res.data);
          }
        });
      },
      listCountry() {
        this.$api.dict("gp_country_list").then(res => {
          if (res.code === 0) {
            this.countryList = res.data;
          }
        });
      },
      currentChange(pageIndex) {
        this.loading = true;
        this.page.pageIndex = pageIndex ? pageIndex : 1;
        let obj = this.$cloud.objMerge(this.search, this.page);
        console.log('Search parameters being sent:', obj);
        this.$api
          .request(this.$url.User.page, this.$method.get, obj)
          .then(res => {
            if (res.code == 0) {
              let userList = res.data.records;
              for (let i = 0; i < userList.length; i++) {
                if (userList[i].roleList && userList[i].roleList.length > 0) {
                  let roleList = userList[i].roleList;
                  if (roleList.length > 0) {
                    let roleListName = "";
                    for (let j = 0; j < roleList.length; j++) {
                      let role = roleList[j];
                      if (role) {
                        if (roleListName) {
                          roleListName += "," + role["name"];
                        } else {
                          roleListName = role["name"];
                        }
                      }
                    }
                    userList[i]["roleListLabel"] = roleListName;
                  } else {
                    userList[i]["roleListLabel"] = "";
                  }
                } else {
                  userList[i]["roleListLabel"] = "";
                }
              }
              this.userList = userList;
              this.page.totalSize = parseInt(res.data.total);
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      onSubmit(data) {
        this.search = data;
        this.currentChange();
      },
      resetSearch(data) {
        this.search = data;
        // Clear sort parameters when resetting
        delete this.search.sort;
        delete this.search.order;
        this.currentChange();
      },
      addUser() {
        this.dialogAddUser = true;
      },
      editUser(row) {
        Object.keys(this.userForm).forEach(key => {
          if (key == "roleList") {
            let userTypeSet = [];
            let roleListSet = [];
            for (let i = 0; i < row["roleList"].length; i++) {
              if (row["roleList"][i]) {
                roleListSet.push(row["roleList"][i]["id"]);
                userTypeSet.push(row["roleList"][i]["value"]);
              }
            }
            this.userForm["userType"] = userTypeSet.length > 0 ? userTypeSet : [];
            this.userForm["roleList"] = roleListSet.length > 0 ? roleListSet : [];
          } else {
            this.userForm[key] = row[key];
          }
        });
        delete this.userForm.password;
        delete this.userForm.checkPassword;
        delete this.userForm.notes;
        this.userForm.id = row.id;
        this.dialogAddUser = true;
      },
      timeZone(row) {
        return this.$cloud.getDictLabel(this.timeZoneList, row.timeZone);
      },
      country(row) {
        return this.$cloud.getDictLabel(this.countryList, row.country);
      },
      cancel(dialog, state) {
        this.dialogAddUser = dialog;
        if (state) {
          this.currentChange(this.page.pageIndex);
        }
      },
      reset(row) {
        this.$confirm(this.$t("user.isReset"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }).then(() => {
          this.$api
            .request(this.$url.User.resetPassword, this.$method.put, {
              id: row.id
            })
            .then(res => {
              if (res.code === 0) {
                this.$alert(
                  this.$t("user.psd") +
                    '<span style="color: red;font-weight: bold;">' +
                    res.data +
                    "</span>" +
                    this.$t("user.storage"),
                  this.$t("user.reset"),
                  { dangerouslyUseHTMLString: true }
                );
              }
            });
        });
      },
      handleCopy(loginLocale) {
        this.$tools.copy(loginLocale);
      },
      handleConsolidateUser(row) {
        this.$confirm(`Consolidate subscriptions for ${row.email || row.userName}?`, "Consolidate", {
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          type: "warning"
        }).then(() => {
          this.consolidatingUserId = row.id;
          this.$api
            .request(this.$url.Stripe.consolidateUser, this.$method.post, { userId: row.id })
            .then(res => {
              if (res.code == 0) {
                this.$message.success("Consolidation complete for " + (row.email || row.userName));
              } else {
                this.$message.warning(res.msg || "Consolidation failed");
              }
            })
            .catch(() => {
              this.$message.warning("Request failed");
            })
            .finally(() => {
              this.consolidatingUserId = null;
            });
        });
      }
    }
  };
</script>

<style lang="scss">
  .team-hub__seg {
    padding: 10px 16px 8px;
  }
  .sh-embed {
    overflow-x: auto;
  }
  .domains {
    .el-dialog__header {
      padding: 20px;
    }
    .el-dialog__footer {
      padding: 20px;
    }
    .el-dialog__body {
      height: auto;
      padding: 0 20px !important;
    }
  }
  .el-form--label-top .el-form-item__label {
    padding: 0 !important;
  }

  .el-form-item {
    margin-bottom: 10px;
  }

  .biaodan {
    width: 92%;
    margin: 0 auto;
    margin-top: 10px;
    padding: 0 4%;
  }

  .biaodan .el-row {
    margin-bottom: 0.1rem;
  }

  .tishi {
    width: 91%;
    margin: 0 auto;
    border-radius: 5px;
    border: 1px solid #ffd77b;
    background-color: #fff9e6;
    margin-top: 6%;
  }

  .tishi .content {
    padding: 2% 3%;
  }

  .el-dialog__body {
    height: auto;
  }
</style>
